import {
  ActiveRecord,
  BaseFieldWidget,
  DslDefinition,
  FormM2MTableFieldWidget,
  ModelFieldType,
  SPI,
  SubmitValue,
  ViewType,
  Widget
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: [
      'deli.platform.promotion.DeliAriesPlatformPromotionPlan',
      'deli.platform.promotion.DeliAriesPlatformPromotionReginPlan',
      'deli.aries.seller.DeliAriesSellerPromotionPlan'
    ],
    viewName: [
      '品牌推广方案表单_FORM_uiViewf42a22827c5340a3b37fd6fd554f115e',
      '区域推广方案表单_FORM_uiView1b7fb5010311402a97b1a086862f8c8d'
    ],
    widget:'Table',
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany
  })
)
export class FormM2MTableDraftWidget extends FormM2MTableFieldWidget {
  public initialize(props: any) {
    super.initialize(props);

    window.addEventListener('message', (e) => {
      if (e.data === 'M2MTableDraftFillData') {
        this.change(this.draftData);
      }
    });

    return this;
  }

  private draftData: ActiveRecord[] = [];

  public getDsl(): DslDefinition {
    // excludeItems里配一个不存在的字段就可以添加重复数据，具体去重逻辑在addSameDat自定义动作中
    return { ...super.getDsl(), excludeItems: ['dlskjfklsd'] };
  }

  async submit(submitValue: SubmitValue) {
    const { itemName, value } = this;
    return { [itemName]: value };
  }

  @Widget.Watch('value')
  watchData(data) {
    if (data.length) {
      this.draftData = data;
    }
  }
}
